import { render, staticRenderFns } from "./ggAndAf.vue?vue&type=template&id=1a33f021&scoped=true"
import script from "./ggAndAf.vue?vue&type=script&lang=js"
export * from "./ggAndAf.vue?vue&type=script&lang=js"
import style0 from "./ggAndAf.vue?vue&type=style&index=0&id=1a33f021&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a33f021",
  null
  
)

export default component.exports